import { makeStyles } from '@material-ui/core/styles';

export const NoteStyles = makeStyles({
  removeAttachment: {
    color: 'blue',
    cursor: 'pointer',
  },
});